import React from 'react'
import {Field, reduxForm, getFormValues, FieldArray} from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import {
    Alert, Button, Card,CardBody,Col, FormGroup, FormText, Label,
    Row
} from "reactstrap";
import renderField from "./renderField";
import renderCheck from "./renderCheck";
import renderFile from "./renderFile";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import DateField from "./renderDate";
import normalizePhone from "./normalizePhone";

const required = value => value ? undefined : 'Merci de remplir ce champ';
const fileMinSize = 4 * 1024 * 1024;
const  displayError = (submitFailed) => {

    if (submitFailed){

        return (
            <Alert color="danger">
                Le formulaire contient des erreurs
            </Alert>
        );
    }

}
const requiredPhone = value => value ? (value.length == 14 ? undefined : 'Numéro de téléphone invalide' ) : 'Merci de remplir ce champ';
const fileSize = value => value ? ((value.size <= fileMinSize) ? undefined : 'Le fichier doit faire moins de 4MB'): 'Merci de remplir ce champ';
const renderMasque1 = ({ fields, meta: { error } }) => (
    <div>
        {fields.map((member, index) =>
            <div key={index}>
                <Alert color="secondary" >
                    <Button type="button" color="danger" onClick={() => fields.remove(index)}>-</Button>
                    <FormGroup>
                        <Label>Nom</Label>
                        <Field name={`${member}.nom`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Prénom</Label>
                        <Field name={`${member}.prenom`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Fonction dans l'entreprise</Label>
                        <Field name={`${member}.fonction`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Email</Label>
                        <Field name={`${member}.email`} type="email" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Adresse personnelle</Label>
                        <Field name={`${member}.add`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Code Postal</Label>
                        <Field name={`${member}.postale`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Ville</Label>
                        <Field name={`${member}.ville`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Téléphone mobile personnel</Label>
                        <Field name={`${member}.mobile`} type="text" component={renderField} validate={requiredPhone} normalize={normalizePhone}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Téléphone fixe personnel</Label>
                        <Field name={`${member}.fix`} type="text" component={renderField}  normalize={normalizePhone}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Détention du nombre de part du capital social (%)</Label>
                        <Field name={`${member}.part`} type="text" component={renderField} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Pièces Justificatives</Label>
                        <Field name={`${member}.id1-${index}`} placeholder="Pièce d'identité recto (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id2-${index}`} placeholder="Pièce d'identité verso (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id3-${index}`} placeholder="Seconde pièce d'identité recto (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id4-${index}`} placeholder="Seconde pièce d'identité verso (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.dom-${index}`} placeholder="Facture de téléphone mobile de moins de 3 mois (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                    </FormGroup>
                </Alert>
            </div>
        )}
        <br/>
        <Button type="button" color="dark" onClick={() => fields.push()}>Ajouter une personne physique entant qu'associé</Button>
        {error && <div className="error">{error}</div>}
    </div>
)


const renderMasque2 = ({ fields, meta: { error } }) => (
    <div>
        {fields.map((member, index) =>
            <div key={index}>
                <Alert color="secondary" >
                    <Button type="button" color="danger" onClick={() => fields.remove(index)}>-</Button>
                    <FormGroup>
                        <Label>Raison social</Label>
                        <Field name={`${member}.raison`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Nom représentant légal</Label>
                        <Field name={`${member}.nom`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Prénom représentant légal</Label>
                        <Field name={`${member}.prenom`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>RCS</Label>
                        <Field name={`${member}.rcs`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Activité</Label>
                        <Field name={`${member}.activite`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Email</Label>
                        <Field name={`${member}.email`} type="email" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Adresse</Label>
                        <Field name={`${member}.adresse`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Code Postal</Label>
                        <Field name={`${member}.postal`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Ville</Label>
                        <Field name={`${member}.ville`} type="text" component={renderField} validate={required}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Téléphone</Label>
                        <Field name={`${member}.fix`} type="text" component={renderField} validate={requiredPhone} normalize={normalizePhone}/>
                    </FormGroup>
                    <FormGroup>
                        <Label>Détention du nombre de part du capital social (%)</Label>
                        <Field name={`${member}.part`} type="text" component={renderField} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Pièces Justificatives</Label>
                        <Field name={`${member}.kbis-${index}`} placeholder="KBIS" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.status-${index}`} placeholder="Statuts" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id1-${index}`} placeholder="Pièce d'identité recto du représentant légal (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id2-${index}`} placeholder="Pièce d'identité verso du représentant légal (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id3-${index}`} placeholder="Seconde pièce d'identité recto du représentant légal (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.id4-${index}`} placeholder="Seconde pièce d'identité verso du représentant légal (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>
                        <Field name={`${member}.dom-${index}`} placeholder="Facture de téléphone mobile de moins de 3 mois du représentant légal (couleur obligatoire, 4MB max)" component={renderFile} validate={fileSize}/>

                    </FormGroup>
                </Alert>
            </div>
        )}
        <br/>
        <Button type="button" color="dark" onClick={() => fields.push()}>Ajouter une personne morale entant qu'associé</Button>
        {error && <div className="error">{error}</div>}
    </div>
)


const validate = values => {
    const errors = {}

    if (values.vousetes && values.vousetes != "resp") {
        if(!values.procuration){
            errors.procuration ='Merci de remplir ce champ'
        }
    }
    if (values.typesoc && values.typesoc == "crea") {
        if(!values.status){
            errors.status ='Merci de remplir ce champ'
        }
    }
    if (values.typesoc && values.typesoc == "dem") {
        if(!values.rib){
            errors.rib ='Merci de remplir ce champ'
        }
        if(!values.siret){
            errors.siret ='Merci de remplir ce champ'
        }
    }
    console.log(errors);
    return errors
}

const ThirdStep = props => {
    let { handleSubmit, formValues, previous,submitFailed } = props;
    if(!formValues){
        formValues = {};
    }

    return (
        <form onSubmit={handleSubmit}>
            {displayError(submitFailed)}
            <FormGroup tag="fieldset">
                <legend>10/ Qui sont les associés de la société à domicilier ?</legend>
                <FieldArray name="physiqueasso" component={renderMasque1}/>
                <br />
                <FieldArray name="moraleasso" component={renderMasque2}/>
            </FormGroup>


            <div>
                <Button onClick={previous}>
                    Retour
                </Button>
                <Button type="submit" className="float-right">
                    Prochaine Etape
                </Button>
            </div>
        </form>
    )
}

function mapStateToProps(state) {
    return {
        formValues: getFormValues('wizard')(state),
    }
}


export default connect(mapStateToProps,null)(reduxForm({
    form: 'wizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
    onSubmitFail: (errors) => window.scrollTo(0, 0),
})(ThirdStep));


// WEBPACK FOOTER //
// ./src/ThirdStep.js